module.exports = __webpack_public_path__ + "static/media/map3-4.96cf27d7.png";